
import { Progress } from "antd";

function TreeProgress({ percentage }) {
    return <>
        {percentage ? <div className="dcol">
            <Progress
                percent={percentage}
                size="small"
                status="active"
                style={{
                    width: "95%",
                }}
            />
            <span>Loading data... please wait.</span>
        </div> : null}</>
}

export default TreeProgress